export const typeCheck = value => {
  return {
    isArray: Object.prototype.toString.call(value) === '[object Array]',
    isObj: Object.prototype.toString.call(value) === '[object Object]',
    isDate: Object.prototype.toString.call(value) === '[object Date]',
    isNull: Object.prototype.toString.call(value) === '[object Null]',
    isUndefined: Object.prototype.toString.call(value) === '[object Undefined]',
    isNum: Object.prototype.toString.call(value) === '[object Number]',
    isString: Object.prototype.toString.call(value) === '[object String]',
    isBoolean: Object.prototype.toString.call(value) === '[object Boolean]',
    isFile: Object.prototype.toString.call(value) === '[object File]',
  };
};
